import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiPost } from '../../api';
import { useInvestorMe } from '../../hooks/useInvestorMe';

export default function InvestorNda() {
  const { me, loading, error, setMe } = useInvestorMe({ enforceNda: false });
  const [accepted, setAccepted] = useState(false);
  const [saving, setSaving] = useState(false);
  const nav = useNavigate();

  const ndaText = useMemo(() => {
    return `CONFIDENTIALITY & NON-DISCLOSURE

The information provided in this Investor Room (including files, metrics and content) is confidential, owned by Quix, and shared solely to evaluate a potential investment.

You agree to:
1) Not forward, share, disclose or redistribute the content to any third party without Quix’s explicit authorization.
2) Not copy or reproduce the content beyond what is strictly necessary for internal evaluation.
3) Maintain reasonable security safeguards to prevent unauthorized access.

Access and actions within the platform (logins, views, downloads) are auditable and are recorded.`;
  }, []);

  const onAccept = async () => {
    setSaving(true);
    try {
      await apiPost('/api/investor/nda', { accepted: true });
      setMe((prev) => (prev ? { ...prev, needsNda: false } : prev));
      nav('/app', { replace: true });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="card">
      <h2 style={{ marginTop: 0 }}>Confidentiality</h2>
      {loading ? <p className="muted">Loading…</p> : null}
      {error ? <p className="muted">We couldn't validate your access. Please reopen your link.</p> : null}
      {me ? (
        <div className="banner" style={{ marginBottom: 12 }}>
          Access for <b>{me.company.name}</b> · NDA version: <b>{me.ndaVersion}</b>
        </div>
      ) : null}
      <textarea className="textarea" value={ndaText} readOnly />
      <div style={{ height: 10 }} />
      <label style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
        <input type="checkbox" checked={accepted} onChange={(e) => setAccepted(e.target.checked)} />
        <span className="muted">
          I accept the confidentiality and non-disclosure terms.
        </span>
      </label>
      <div style={{ height: 12 }} />
      <button className="btn primary" disabled={!accepted || saving || !!error} onClick={onAccept}>
        {saving ? 'Saving…' : 'Accept and continue'}
      </button>
    </div>
  );
}
